'use strict';

const P = require('./protocol.js'); // No provider buttons/requests are implemented here. The installed SDK keeps its original page.


async function navigateOriginalPayment(quote, {
  prepare,
  navigate,
  now = Date.now
} = {}) {
  P.quote(quote, quote === null || quote === void 0 ? void 0 : quote.skuId);
  P.check(quote.status === 'PAYABLE', 'CARD_QUOTE_NOT_PAYABLE');
  P.check(quote.expiresAt > now(), 'CARD_QUOTE_EXPIRED');
  P.check(typeof prepare === 'function' && typeof navigate === 'function', 'ORIGINAL_PAYMENT_ADAPTER_NOT_INSTALLED');
  const result = await prepare({
    opCardQuoteId: quote.quoteId,
    opCardQuoteHash: quote.quoteHash
  });
  P.check((result === null || result === void 0 ? void 0 : result.schema) === 'op-card-original-payment-route-v1' && result.route === '/payment-providers' && result.quoteId === quote.quoteId && result.quoteHash === quote.quoteHash, 'UNREVIEWED_PAYMENT_ROUTE');
  const query = result.query;
  P.check(query && Object.keys(query).sort().join(',') === 'currency,opCardQuoteHash,opCardQuoteId,productId' && /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i.test(query.productId) && query.currency === quote.currency && query.opCardQuoteId === quote.quoteId && query.opCardQuoteHash === quote.quoteHash, 'UNBOUND_PAYMENT_PRODUCT'); // The adapter must itself verify the server product/context support. Existing ordinary routes reject card-only SKUs.

  P.check(result.cardPackProtocol === 'OP_CARD_QUOTE_V1' && result.paymentHandlersReady === true, 'CARD_PAYMENT_HANDLERS_NOT_READY');
  P.check(quote.expiresAt > now(), 'CARD_QUOTE_EXPIRED');
  const search = new URLSearchParams(query).toString();
  navigate('/payment-providers/?' + search);
}

module.exports = {
  navigateOriginalPayment
};
